<template>
  <div class="add-tag-group-c">
    <div class="add-tag-group-c-content">
      <div class="header">
        <h3>添加标签组</h3>
        <mk-iconfont
          class="close"
          icon-class="guanbi"
          @click.native="cancel"
        ></mk-iconfont>
      </div>
      <div class="con">
        <span class="icon">*</span>
        <span class="txt">标签组名称：</span>
        <mk-input
          v-model="name"
          width="220"
          maxlength="8"
          show-word-limit
          placeholder="输入标签组名称"
        />
      </div>
      <div class="btn-group">
        <mk-button-biz
          width="64px"
          @click="cancel"
        >
          取消
        </mk-button-biz>
        <mk-button-biz
          type="primary"
          width="64px"
          @click="confirm"
        >
          确认
        </mk-button-biz>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    initName: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'add'
    },
    editInfo: {
      type: Object,
      default () {
        return {}
      }
    },
    tagApis: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      name: ''
    }
  },
  created () {
    if (this.type === 'edit') {
      this.name = this.editInfo.name
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    },
    confirm () {
      if (this.name !== '') {
        if (this.type === 'add') {
          this.addTagGroup()
        } else {
          this.editTagGroup()
        }
      } else {
        this.$message({
          type: 'error',
          message: '请输入标签组名称',
          showClose: true
        })
      }
    },
    async addTagGroup () {
      const res = await this.tagApis.v1TagCompanyGroupPost({
        name: this.name
      })
      if (res.success) {
        this.$message({
          type: 'success',
          message: '添加标签组成功',
          showClose: true
        })
        this.$emit('cancel')
        this.$emit('update')
      }
    },
    async editTagGroup () {
      const res = await this.tagApis.v1TagNamePatch({
        id: this.editInfo.id,
        name: this.name
      })
      if (res.success) {
        this.$message({
          type: 'success',
          message: '编辑标签组成功',
          showClose: true
        })
        this.$emit('cancel')
        this.$emit('update')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.add-tag-group-c {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
  position: fixed;
  top: 0;
  left: 0;

  .add-tag-group-c-content {
    width: 390px;
    background-color: #fff;
    position: absolute;
    top: 40%;
    right: 305px;
    transform: translate3d(0, -50%, 0);

    .header {
      width: 100%;
      height: 54px;
      box-sizing: border-box;
      padding: 0 20px;
      margin: 0 auto;
      display: flex;
      box-shadow: 0 -1px 0 0 rgba(232, 232, 232, 1) inset;
      border-radius: 4px 4px 0 0;
      justify-content: space-between;
      align-items: center;

      h3 {
        font-size: 14px;
      }

      .close {
        cursor: pointer;
        font-size: 14px;
        color: #bfbfbf;
      }
    }

    .con {
      width: calc(100% - 60px);
      margin: 0 auto;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 32px 0 40px 0;

      .icon {
        color: #e02020;
        margin: 6px 4px 0 0;
      }

      .txt {
        color: #262626;
        font-size: 13px;
      }
    }

    .btn-group {
      height: 52px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-top: 1px solid rgba(0, 0, 0, 0.09);
    }
  }
}
</style>
